import { Box, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import Header from '../../components/Header';
import { useTranslation } from '../../hooks/useTranslation';
import { DataContext } from '../../contexts/DataContext';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import DateSelect from '../../components/DateSelect';
import Under18Dialog from '../../components/Under18Dialog';
function isAbove18(birthdate) {
  // Convert the birthdate string to a Date object
  const birthDate = new Date(birthdate);

  // Get the current date
  const currentDate = new Date();

  // Calculate the difference in years
  let age = currentDate.getFullYear() - birthDate.getFullYear();

  // Adjust the age if the birthday hasn't occurred yet this year
  const monthDifference = currentDate.getMonth() - birthDate.getMonth();
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  // Check if the user is above 18
  return age >= 18;
}

function DobPage() {
  const { t } = useTranslation();
  const { steps, currentStep, data, setData, setCurrentStep, trackEvent } =
    useContext(DataContext);
  const [isDisabled, setIsDisabled] = useState(false);
  const onSubmit = () => {
    if (!isAbove18(new Date(data?.dob))) {
      setData({ ...data, errors: { ...data?.errors, dob: true } });
      setIsDisabled(true);
      return;
    }
    if (data?.country?.includes('lux')) setCurrentStep(currentStep + 1);
    else {
      //setCurrentStep(currentStep + 1);
      setCurrentStep(currentStep + 1);
    }
  };
  useEffect(() => {
    trackEvent({ nav_birth_date: 1 });
  }, [trackEvent]);

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
      }}
    >
      <Under18Dialog
        isOpen={data?.errors?.dob}
        setIsOpen={(v) =>
          setData({ ...data, errors: { ...data?.errors, dob: v } })
        }
      />
      <Header steps={steps} currentStep={currentStep} />
      <div
        style={{
          marginTop: '83px',
          display: 'flex',
          flexDirection: 'column',
          paddingInline: '24px',
          alignItems: 'stretch',
        }}
      >
        <Typography
          sx={{
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '38.46px',
          }}
        >
          {t('dobPage.title')}
        </Typography>
        <Box
          sx={{
            marginTop: '48px',
            width: '100%',
            position: 'relative',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
          }}
        >
          <DateSelect
            currentDate={data?.dob}
            setCurrentDate={(v) => {
              setData({
                ...data,
                dob: v,
                errors: { ...data?.errors, dob: false },
              });
              setIsDisabled(false);
            }}
            t={t}
          />
        </Box>
      </div>
      <FloatingActions childrenStyle={{}}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            paddingInline: '24px',
          }}
        >
          <button
            onClick={() => {
                
              if (data?.country.includes('lux'))
                setCurrentStep(currentStep - 1);
              else {
                //setCurrentStep(currentStep - 1);
                setCurrentStep(0);
              }
            }}
            style={{
              outline: 'none',
              border: 'none',
              borderRadius: '50%',
              width: '57px',
              height: '57px',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="57"
              height="57"
              viewBox="0 0 57 57"
              fill="none"
            >
              <rect
                opacity="0.1"
                width="57"
                height="57"
                rx="28.5"
                transform="matrix(-1 0 0 1 57 0)"
                fill="#44546A"
              />
              <path
                d="M35 29H22M22 29L27.2 24M22 29L27.2 34"
                stroke="#44546A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <PrimaryButton
            style={{ flex: 1 }}
            onClick={onSubmit}
            disabled={isDisabled}
          >
            {t('continue')}
          </PrimaryButton>
        </div>
      </FloatingActions>
    </Box>
  );
}

export default DobPage;
